module.exports = __webpack_public_path__ + "static/media/HireRectangleBlue.0d537359.svg";